import { render, staticRenderFns } from "./TrainingSubscribedCompany.vue?vue&type=template&id=6dd4fe5c"
import script from "./TrainingSubscribedCompany.vue?vue&type=script&lang=js"
export * from "./TrainingSubscribedCompany.vue?vue&type=script&lang=js"
import style0 from "./TrainingSubscribedCompany.vue?vue&type=style&index=0&id=6dd4fe5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports